import { render } from "./AddAbonnePage.vue?vue&type=template&id=24846be3&ts=true"
import script from "./AddAbonnePage.vue?vue&type=script&lang=ts"
export * from "./AddAbonnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__